import { Box, FlexBox, Icon, Text, Tooltip } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import type { OpeningHours } from 'lib-shared-types-api';
import moment from 'moment-timezone';

import { getFormattedDate } from 'components/settings/components/sections/openingHours/views/schedule/utils/format';

import { isFebruary29 } from '../../utils/date';

import styles from './listItemHeader.module.scss';

type Props = Pick<OpeningHours, 'duration' | 'name' | 'recurring'> & {
  hasConflict?: boolean;
  openingHourType: OpeningHours['opening_hour_type'];
  nextDate: OpeningHours['next_date'];
};

export const ListItemHeader = ({
  hasConflict,
  name,
  nextDate,
  openingHourType,
  recurring,
}: Props): JSX.Element => {
  const exceptionToolTipText = isFebruary29(moment.utc(nextDate))
    ? 'Exception repeats every 4 years on this date'
    : 'Exception repeats annually on this date';

  return openingHourType === 'regular' ? (
    <Box className={styles.name}>
      <Text.Paragraph clamp={2} variant="1">
        {name}
      </Text.Paragraph>
    </Box>
  ) : (
    <>
      <FlexBox alignItems="flex-start" gap="8px">
        {hasConflict && (
          <Icon
            className={styles.iconConflict}
            color={colors.red['800']}
            name="exclamation-triangle-filled"
          />
        )}
        <div className={styles.nameAndDate}>
          <FlexBox height="16px">
            <Text.Paragraph className={styles.exception} variant="5">
              {name}
            </Text.Paragraph>
            {recurring && (
              <Tooltip
                dark
                content={
                  openingHourType === 'exception'
                    ? exceptionToolTipText
                    : 'Exception repeats annually on this holiday'
                }
                side="left"
                wrap="none"
              >
                <span className={styles.iconWrapper}>
                  <Icon className={styles.icon} name="sync" />
                </span>
              </Tooltip>
            )}
          </FlexBox>
          <Text.Paragraph className={styles.date} clamp={1}>
            {getFormattedDate(nextDate as string)}
          </Text.Paragraph>
        </div>
      </FlexBox>
    </>
  );
};
